module.exports = __webpack_public_path__ + "static/media/icon-venda.e912c659.svg";